export default __webpack_public_path__ + "static/149316664_5061191460621066_7360931095495474471_n-4d0227b5858df595dcdd856d71748095.jpg";